import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Divider from '@material-ui/core/Divider'

import Grid from '@material-ui/core/Grid'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import styles from './EarningsCalculator.styles'
import EarningsChart from '../../components/Chart'
import { isToggleActive } from '../../utils/feature-toggle'
import Chart1 from '../../../resources/assets/images/earningscalculator/chart1.svg'
import Chart2 from '../../../resources/assets/images/earningscalculator/chart2.svg'
import { toCurrencyStrategy } from './utils/toCurrencyStrategy'
import { getDisclaimerMessage, getDisclaimerOnlineSaleMessage, getOnlineSaleCommissionMessage } from './strategies'

const PureEarningsCalculatorResults = ({
  classes,
  chartLevels,
  chartInfo,
  onlineChartInfo,
  tabActive,
  langKey = ''
}) => {
  const isF2FSales = () => {
    return tabActive === 0
  }

  const info = onlineChartInfo && !isF2FSales() ? onlineChartInfo : chartInfo

  const {
    frontmatter: { currency, kitPrice, separator }
  } = info[0].node

  return (
    <Grid
      direction="column"
      alignItems="flex-start"
      className={classes.earningResults}
      container
    >
      <Grid className={classes.earningsCalculatorInfo} item>
        <span className={classes.earningsCalculatorChartResult}>
          <FormattedMessage id="earningsCalculatorChartResultText" />
        </span>
        <span className={classes.earningsCalculatorChartMoney}>
          <span className={classes.earningsCalculatorChartSign}>
            {currency}
          </span>{' '}
          {toCurrencyStrategy(kitPrice, separator, langKey)}
        </span>
      </Grid>
      <Divider classes={{ root: classes.earningsCalculatorDivider }} />
      <Grid item>
        <p className={classes.earningsCalculatorChartDescription}>
          <FormattedHTMLMessage
            id="earningsCalculatorChartResultDescription"
            values={{ salesType: isF2FSales() }}
          />
        </p>
      </Grid>
      <Grid className={classes.chartImage} item>
        {!isToggleActive('CSS_CHART') && (
          <EarningsChart
            id="earnings-calculator-results-chart"
            caption="Gráfico demonstrando os ganhos com venda"
            chartLevels={chartLevels}
            currency={currency}
            separator={separator}
            data-testid="earnings-calculator-chart-internet-seed"
            baseAmount={kitPrice}
            baseHeight={isF2FSales() ? 85 : 68}
            isF2FSales={isF2FSales()}
            langKey={langKey}
          />
        )}
        {isToggleActive('CSS_CHART') && (
          <>
            {tabActive !== 0 && (
              <img
                className={classes.chartImage}
                id="earnings-calculator-results-chart"
                alt="Gráfico demonstrando os ganhos com vendas presenciais"
                aria-hidden={true}
                src={Chart1}
              />
            )}
            {tabActive === 0 && (
              <img
                className={classes.chartImage}
                id="earnings-calculator-results-chart"
                alt="Gráfico demonstrando os ganhos com vendas pela internet"
                aria-hidden={true}
                src={Chart2}
              />
            )}
          </>
        )}
        {!isF2FSales() && getOnlineSaleCommissionMessage(langKey)}
        {!isF2FSales() && getDisclaimerOnlineSaleMessage(langKey, !isF2FSales())}
        {isF2FSales() && getDisclaimerMessage(langKey, isF2FSales())}
      </Grid>
    </Grid>
  )
}

const EarningsCalculatorResults = withStyles(styles)(
  PureEarningsCalculatorResults
)

export default EarningsCalculatorResults
